import { render } from "./KinkekaardidView.vue?vue&type=template&id=203ceb4f"
import script from "./KinkekaardidView.vue?vue&type=script&lang=js"
export * from "./KinkekaardidView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__